"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var node_1 = require("tstl/utility/node");
if (node_1.is_node())
    global.WebSocket = require("./WebSocket").WebSocket;
//# sourceMappingURL=index.js.map